<template>
  <div class="cmp-catalog-releases-sidewindow-chart-container">
    <div
      v-if="
        salesTypeChartData &&
        salesTypeChartData.labels &&
        salesTypeChartData.labels.length > 0
      "
      class="chart-content full-content"
    >
      <span class="chart_header">{{$t('turnover_by_sales_type')}}</span>
      <div class="chart">
        <div class="legend">
          <v-list>
            <v-list-tile
              v-for="(label, i) in salesTypeChartData.labels"
              :key="i"
              @click="onClick(label, i)"
              ><div
                class="circle"
                :style="{
                  backgroundColor: `${salesTypeChartData.datasets[0].backgroundColor[i]}`,
                }"
              ></div>
              <v-list-tile-content>
                <span :title="label.text" class="label_title">{{
                  label.text
                }}</span
                ><span :title="label.percentage" class="percentage">{{
                  label.percentage
                }}</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
        <div
          style="width: 70%; margin: 0 80px"
          v-if="!isLoadingChart"
          class="chart_"
        >
          <BarVerticalChart
            :chartdata="salesTypeChartData"
            :title="$t('detailsb2b_release')"
          />
        </div>
      </div>
    </div>
    <div
      v-if="topTracksItems && topTracksItems.length > 0"
      class="chart-content"
    >
      <span class="chart_header">{{$t('top_tracks')}}</span>
      <div class="chart">
        <TopTracksTable :items="topTracksItems" />
      </div>
    </div>

    <div
      v-if="
        digitalShopChartData &&
        digitalShopChartData.labels &&
        digitalShopChartData.labels.length > 0
      "
      class="chart-content"
    >
      <span class="chart_header">
        {{ `${$t("digital_sales")} ${$t("by")} ${$t("shop")}` }}
      </span>
      <div class="chart">
        <div class="legend">
          <v-list>
            <v-list-tile
              v-for="(label, i) in digitalShopChartData.labels"
              :key="i"
              @click="onClick(label, i)"
              ><div
                class="circle"
                :style="{
                  backgroundColor: `${digitalShopChartData.datasets[0].backgroundColor[i]}`,
                }"
              ></div>
              <v-list-tile-content>
                <span :title="label.text" class="label_title">{{
                  label.text
                }}</span
                ><span :title="label.percentage" class="percentage">{{
                  label.percentage
                }}</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
        <div v-if="!isLoadingChart" class="chart_">
          <DoughnutChart
            :chartdata="digitalShopChartData"
            :title="$t('detailsb2b_shop_turnover')"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        countryChartData &&
        countryChartData.labels &&
        countryChartData.labels.length > 0
      "
      class="chart-content"
    >
      <span class="chart_header">{{$t('turnover_by_country')}}</span>
      <div class="chart">
        <div class="legend">
          <v-list>
            <v-list-tile
              v-for="(label, i) in countryChartData.labels"
              :key="i"
              @click="onClick(label, i)"
              ><div
                class="circle"
                :style="{
                  backgroundColor: `${countryChartData.datasets[0].backgroundColor[i]}`,
                }"
              ></div>
              <v-list-tile-content>
                <span :title="label.text" class="label_title">{{
                  label.text
                }}</span
                ><span :title="label.percentage" class="percentage">{{
                  label.percentage
                }}</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
        <div v-if="!isLoadingChart" class="chart_">
          <DoughnutChart
            :chartdata="countryChartData"
            :title="$t('detailsb2b_shop_turnover')"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        physicalChartData &&
        physicalChartData.labels &&
        physicalChartData.labels.length > 0
      "
      class="chart-content"
    >
      <span class="chart_header">{{$t('physical_turnover_by_product')}}</span>
      <div class="chart">
        <div class="legend">
          <v-list>
            <v-list-tile
              v-for="(label, i) in physicalChartData.labels"
              :key="i"
              @click="onClick(label, i)"
              ><div
                class="circle"
                :style="{
                  backgroundColor: `${physicalChartData.datasets[0].backgroundColor[i]}`,
                }"
              ></div>
              <v-list-tile-content>
                <span :title="label.text" class="label_title">{{
                  label.text
                }}</span
                ><span :title="label.percentage" class="percentage">{{
                  label.percentage
                }}</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
        <div v-if="!isLoadingChart" class="chart_">
          <DoughnutChart
            :chartdata="physicalChartData"
            :title="$t('detailsb2b_shop_turnover')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";
import BarVerticalChart from "./charts/bar-vertical-chart";
import TopTracksTable from "./charts/top-tracks-table.vue";
import DoughnutChart from "./charts/doughnut-chart";
import { mapGetterObject } from "../../../../store/global";
import { releasesCatalogGetters } from "../../store/releases/getters";
import { CatalogStoreNamespace as storeNS } from "../../store";

export default {
  components: {
    GChart,
    BarVerticalChart,
    DoughnutChart,
    TopTracksTable,
  },
  data: function () {
    return {
      isLoadingChart: false,
    };
  },
  computed: {
    ...mapGetterObject(storeNS, releasesCatalogGetters),
    release_id: function () {
      return this.$route.params.release_id;
    },
    topTracksItems: function () {
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_charts = releaseDetails.sales_charts || {};
      let tracks = sales_charts.tracks || [];
      tracks =
        tracks.map((t) => {
          t.chart_total = t.chart_total
            ? Number(t.chart_total).toFixed(2)
            : 0.0;
          return t;
        }) || [];

      return tracks.slice(0, 9);
    },
    countryChartData: function () {
      this.isLoadingChart = true;
      setTimeout(() => {
        this.isLoadingChart = false;
      }, 10);
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      // const sales_charts = releaseDetails.sales_charts || {};

      const countries =
        releaseDetails?.sales_report?.countries
          ?.filter((c) => {
            return c.amount > 0;
          })
          .sort((a, b) => {
            return b.amount - a.amount;
          }) || [];

      if (countries.length == 0) {
        return {};
      }

      // let report = {
      //   labels: [],
      //   datasets: [
      //     {
      //       label: "Digital Turnover",
      //       backgroundColor: "#4FE890",
      //       data: [],
      //       backgroundColor: [
      //         "#64C896",
      //         "#E6DC64",
      //         "#FF6E6E",
      //         "#AFAFAF",
      //         "#44A1B7",
      //         "#F0A152",
      //         "#385090",
      //         "#121212",
      //         "#5DA771",
      //         "#E682BE",
      //       ],
      //     },
      //   ],
      // };

      // const data = {
      //   labels: [
      //     'Red',
      //     'Blue',
      //     'Yellow'
      //   ],
      //   datasets: [{
      //     label: 'My First Dataset',
      //     data: [300, 50, 100],
      //     backgroundColor: [
      //       'rgb(255, 99, 132)',
      //       'rgb(54, 162, 235)',
      //       'rgb(255, 205, 86)'
      //     ],
      //     hoverOffset: 4
      //   }]
      // };

      const total = countries.reduce((acc, curr) => {
        return acc + curr.amount;
      }, 0);

      const tobeShownCountries = countries
        .map((e) => {
          return {
            ...e,
            percentage: (e.amount / total) * 100,
          };
        })
        .slice(0, 9);

      const report = {
        labels: tobeShownCountries.map((e) => {
          return {
            text: e.iso2,
            click: false,
            percentage: e.percentage.toFixed(2) + "%",
            tooltip: `${e.iso2} ${this.$dft.money(e.amount, this.$store.getters.account.client.default_currency)} (${e.percentage.toFixed(2) + "%"})`,
          };
        }),
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: tobeShownCountries.map((e) => {
              return e.amount;
            }),
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#AFAFAF",
              "#44A1B7",
              "#F0A152",
              "#385090",
              "#121212",
              "#5DA771",
              "#E682BE",
            ],
          },
        ],
      };

      // let countriesTV = countries.slice(0, 9).map((c, index) => {
      //   c.chart_total = c.chart_total ? c.chart_total : 0;
      //   return c;
      // });
      // const total_country = countriesTV
      //   .map((c) => Math.abs(c?.chart_total))
      //   .reduce((accm, cur) => accm + cur, 0);

      // countriesTV.forEach((e) => {
      //   let salePercentage = (Math.abs(e.chart_total) / total_country) * 100;
      //   report.labels.push({
      //     text: e.chart_description,
      //     click: false,
      //     percentage: salePercentage.toFixed(2) + "%",
      //   });
      //   report.datasets[0].data.push(e.chart_total);
      // });

      return report;
    },
    /**
     * Why was this using the sales_charts data ? It should've been using the sales_report data
     * Disabled on 2023-11-13
     */
    // countryChartDataFromSalesChart: function () {
    //   this.isLoadingChart = true;
    //   setTimeout(() => {
    //     this.isLoadingChart = false;
    //   }, 10);
    //   const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

    //   const sales_charts = releaseDetails.sales_charts || {};

    //   const countries = sales_charts.countries || [];

    //   if (countries.length == 0) {
    //     return {};
    //   }
    //   let report = {
    //     labels: [],
    //     datasets: [
    //       {
    //         label: "Digital Turnover",
    //         backgroundColor: "#4FE890",
    //         data: [],
    //         backgroundColor: [
    //           "#64C896",
    //           "#E6DC64",
    //           "#FF6E6E",
    //           "#AFAFAF",
    //           "#44A1B7",
    //           "#F0A152",
    //           "#385090",
    //           "#121212",
    //           "#5DA771",
    //           "#E682BE",
    //         ],
    //       },
    //     ],
    //   };
    //   let countriesTV = countries.slice(0, 9).map((c, index) => {
    //     c.chart_total = c.chart_total ? c.chart_total : 0;
    //     return c;
    //   });
    //   const total_country = countriesTV
    //     .map((c) => Math.abs(c?.chart_total))
    //     .reduce((accm, cur) => accm + cur, 0);

    //   countriesTV.forEach((e) => {
    //     let salePercentage = (Math.abs(e.chart_total) / total_country) * 100;
    //     report.labels.push({
    //       text: e.chart_description,
    //       click: false,
    //       percentage: salePercentage.toFixed(2) + "%",
    //     });
    //     report.datasets[0].data.push(e.chart_total);
    //   });

    //   return report;
    // },
    digitalShopChartData: function () {
      this.isLoadingChart = true;
      setTimeout(() => {
        this.isLoadingChart = false;
      }, 10);
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};

      const digital_shop_sales = sales_report.digital_shop_sales || [];

      if (digital_shop_sales.length == 0) {
        return {};
      }
      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#AFAFAF",
              "#44A1B7",
              "#F0A152",
              "#385090",
              "#121212",
              "#5DA771",
              "#E682BE",
            ],
          },
        ],
      };
      let digital_shop_salesTV = digital_shop_sales
        .slice(0, 9)
        .map((c, index) => {
          c.total_turnover = c.total_turnover ? c.total_turnover : 0;
          return c;
        });
      const digital_shop_sales_total = digital_shop_salesTV
        .map((c) => Math.abs(c?.total_turnover))
        .reduce((accm, cur) => accm + cur, 0);

      digital_shop_salesTV.forEach((e) => {
        let salePercentage =
          (Math.abs(e.total_turnover) / digital_shop_sales_total) * 100;
        report.labels.push({
          text: e.shop,
          click: false,
          percentage: salePercentage.toFixed(2) + "%",
        });
        report.datasets[0].data.push(e.total_turnover);
      });

      return report;
    },
    physicalChartData: function () {
      this.isLoadingChart = true;
      setTimeout(() => {
        this.isLoadingChart = false;
      }, 10);
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};

      const physical_product_sales = sales_report.physical_product_sales || [];

      if (physical_product_sales.length == 0) {
        return {};
      }
      let report = {
        labels: [],
        datasets: [
          {
            label: "Digital Turnover",
            backgroundColor: "#4FE890",
            data: [],
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#AFAFAF",
              "#44A1B7",
              "#F0A152",
              "#385090",
              "#121212",
              "#5DA771",
              "#E682BE",
            ],
          },
        ],
      };
      let physical_product_salesTV = physical_product_sales
        .slice(0, 9)
        .map((c, index) => {
          c.total_turnover = c.total_turnover ? c.total_turnover : 0;
          return c;
        });
      const total_physical_product_sales = physical_product_salesTV
        .map((c) => Math.abs(c?.total_turnover))
        .reduce((accm, cur) => accm + cur, 0);

      physical_product_salesTV.forEach((e) => {
        let salePercentage =
          (Math.abs(e.total_turnover) / total_physical_product_sales) * 100;

        report.labels.push({
          text: e.catalog_no,
          click: false,
          percentage: salePercentage.toFixed(2) + "%",
        });
        report.datasets[0].data.push(e.total_turnover);
      });

      return report;
    },

    salesTypeChartData: function () {
      this.isLoadingChart = true;
      setTimeout(() => {
        this.isLoadingChart = false;
      }, 10);
      const releaseDetails = (this.releaseDetails || {})[this.release_id] || {};

      const sales_report = releaseDetails.sales_report || {};

      const sales_type = sales_report.sales_type || [];

      if (sales_type.length === 0) {
        return {};
      }
      let report = {
        labels: [],
        datasets: [
          {
            label: "Release 2020",
            backgroundColor: [
              "#64C896",
              "#E6DC64",
              "#FF6E6E",
              "#7878F0",
              "#E682BE",
            ],
            data: [],
            barThickness: 8,
            barPercentage: 0.5,
            xAxis: {
              labels: {
                useHTML: true,
                style: {
                  width: 100,
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              },
            },
          },
        ],
      };
      sales_type
        .filter((s) => s[1] > 0)
        .slice(0, 9)
        .forEach((e, index) => {
          report.labels.push({
            text: e[0],
            percentage: e[1].toFixed(2) + ` €`,
          });
          report.datasets[0].data.push(e[1]);
        });
      return report;
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-chart-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  gap: 1rem;
  margin-top: 20px;
  margin-bottom: 30px;
  .dt-ntable tbody tr:last-child {
    border-bottom: none;
  }
  .chart-content {
    display: flex;
    border: 1px solid #fff;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000015;
    border-radius: 15px;
    opacity: 1;
    width: 49%;
    overflow: auto;
    flex-direction: column;
    height: 400px;
    &:hover {
      --fc2-bc: var(--bc-cblue);
      border: 1px solid #9b9a9a80;
    }
    @media (min-width: 320px) and (max-width: 800px) {
      width: 100%;
    }
    &.full-content {
      width: 99.5%;
    }
    .chart_header {
      color: #282828;
      font-size: 14px;
      margin-top: 22px;
      padding-bottom: 20px;
      font-weight: 500;
      padding-left: 20px;
    }
    .chart_ {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding: 5px;
      height: 100%;

      div {
        display: flex !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow: hidden;
        margin: 30px 8px 60px 0;
        canvas {
          height: none !important;
        }
        @media (min-width: 320px) and (max-width: 800px) {
          margin-bottom: 0px;
        }
      }
    }
    .chart {
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      align-items: center;
      overflow: hidden;
      height: 100%;
      width: 100%;
      .legend {
        display: flex;
        flex-direction: column;
        margin-bottom: 60px;
        overflow: hidden;
        width: 45%;
        padding-left: 20px;
        @media only screen and (max-width: 992px) {
          width: 50%;
        }
        .list .list__tile--link:hover {
          background: none !important;
        }
        .list__tile {
          display: flex;
          align-items: center;
          height: 24px;
          font-size: 14px;
          padding: 0px;
          .circle {
            width: 10px;
            height: 9px;
            border-radius: 50%;
          }

          .list__tile__content {
            padding-left: 5px;

            cursor: pointer;
            width: 100%;
            line-height: 24px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .label_title {
              color: #282828;
              font: normal normal medium 14px/20px Roboto;
              padding: 0 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &.strikethrough {
                position: relative;
              }

              &.strikethrough:before {
                border-bottom: 2px solid #757373;
                position: absolute;
                content: "";
                width: 95%;
                height: 55%;
              }
            }
            .percentage {
              color: #868686;
              font: normal normal medium 14px/20px Roboto;
            }
          }
        }
      }
      .chart_ {
        display: flex;
        height: 100%;
        overflow: hidden;

        justify-content: flex-end;

        div {
          display: flex !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow: hidden;
          margin: 30px 8px 60px 0;
          canvas {
            height: none !important;
          }
          @media (min-width: 320px) and (max-width: 800px) {
            margin-bottom: 0px;
          }
        }
      }
    }
  }
}
</style>